export const getSiteAssetsBaseUrl = (serviceTopology: Record<string, any>) =>
    serviceTopology?.siteAssetsServerUrl || 'https://siteassets.parastorage.com/pages'
